export type DynamicFieldType = {
    [key:string]: string
}

export type DynamicFieldValueType = {
    [key:string]: number
}

export interface DynamicFieldsResponse {
    fields_types: DynamicFieldType;
    fields_values: DynamicFieldValueType;
}

export const dynamicFieldsTypes: DynamicFieldType = {
    "0": "checkbox",
    "1": "input",
    "2": "combobox",
    "3": "switch",
    "4": "multi_combobox"
 }

 export const dynamicFieldsValueTypes: DynamicFieldValueType = {
    "int": 0,
    "string": 1,
    "boolean": 2
}